module.exports = __webpack_public_path__ + "static/img/S.a32c15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/S.png
// module id = Kr7N
// module chunks = 0